import React, {Fragment, useContext, useState} from 'react';
import {Btn} from '../../../../AbstractElements';
import {Form, FormGroup, Label} from 'reactstrap';
import axiosConfig from '../../../../Config/axios';
import {useForm} from "react-hook-form";
import TextInput from "../../../../CommonElements/Input/TextInput";
import Loader from "../../../../Layout/Loader";
import AuthorizationContext from "../../../../_helper/Authorization";
import MultimediaField from "../../../SystemCore/Multimedia/Component/MultimediaField";
import {UserFormProps, UserFormValues, User} from "../Types/UserTypes";
import type {AuthorizationContextType} from "../../../../_helper/Authorization/AuthorizationTypes";

const UserForm = ({callBack, isUpdate}: UserFormProps) => {
    const [loaderVisibility, setLoaderVisibility] = useState(false);
    const [togglePassword, setTogglePassword] = useState(false);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};

    const {
        register,
        handleSubmit,
        setError,
        clearErrors,
        formState: {errors},
        setValue,
    } = useForm<UserFormValues>();

    const onSubmit = (data: UserFormValues) => {
        clearErrors();
        setLoaderVisibility(true);
        if (togglePassword) {
            data.password_confirmation = data.password;
        }
        axiosConfig
            .post(`/privilege/user`, data)
            .then((response: { data: { data: User; }; }) => {
                if (response?.data?.data) {
                    callBack && callBack(response.data.data);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception, setError as any);
                setLoaderVisibility(false);
            });
    }

    return (
        <Fragment>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Loader visibility={loaderVisibility}/>
                <TextInput name={'name'} type={'text'} label={'Name'} register={register}
                           errors={errors} placeholder={'Kasun Samanpriya'} options={{required: true}}/>
                <TextInput name={'email'} type={'email'} label={'Email Address'} register={register}
                           errors={errors} placeholder={'Test@gmail.com'} options={{required: true}}/>
                <MultimediaField
                    name={'multimedia_id'}
                    label={'Profile Multimedia'}
                    register={register}
                    setValue={setValue}
                    errors={errors}
                    helperText={'Upload a file and the returned multimedia id will be sent with the form.'}
                />
                <FormGroup className='position-relative'>
                    <Label className='col-form-label m-0'>Password</Label>
                    <div className='position-relative'>
                        <input className='form-control' type={togglePassword ? 'text' : 'password'}
                               {...register('password', {required: true})}
                               placeholder='*********'/>
                        <div className='show-hide' onClick={() => setTogglePassword(!togglePassword)}>
                            <span className={togglePassword ? '' : 'show'}></span>
                        </div>
                    </div>
                    <span
                        className='d-block invalid-feedback'>{errors.password && (errors.password.message ? errors.password.message : 'Please provide a valid password')}</span>
                </FormGroup>
                {togglePassword ? null : <FormGroup className='position-relative'>
                    <Label className='col-form-label m-0'>Confirm Password</Label>
                    <div className='position-relative'>
                        <input className='form-control' type={togglePassword ? 'text' : 'password'}
                               {...register('password_confirmation', {required: true})}
                               placeholder='*********'/>
                    </div>
                    <span
                        className='d-block invalid-feedback'>{errors.password_confirmation && (errors.password_confirmation.message ? errors.password_confirmation.message : 'Please provide a valid password')}</span>
                </FormGroup>}
                <FormGroup>
                    <Btn attrBtn={{
                        className: 'd-block w-100 mt-4',
                        color: 'primary',
                        type: 'submit'
                    }}>{isUpdate ? 'Update' : 'Create'}</Btn>
                </FormGroup>
            </Form>
        </Fragment>
    );
};

export default UserForm;
